module.exports = __webpack_public_path__ + "static/media/ic_arrow.c6606774.svg";